// lamelarea.factory.ts
import {LamelareaImpl} from './lamelarea.class';
import {v4 as uuid} from 'uuid';
import {LamellaSetFactory} from "./lamel/lamella-set.factory";
import {LamellaListingItem} from "../../types/lamella-listing-item.type";
import {MountingProfileFactory} from "./profiles/mounting-profile/mounting-profile.factory";


export class LamelareaFactory {

    static createLamelarea(order : number, groupId : string): LamelareaImpl {
        const lamellaSets = [LamellaSetFactory.createLamellaSet()];
        return new LamelareaImpl(
            uuid(),
            order,
            "No name",
            groupId,
            lamellaSets,
            lamellaSets.length,
            "horizontal",

            true,
            3000,
            2000,
            true,

            null,
            MountingProfileFactory.createProfile(),
            null,

            true,
            false,

            true,
        );
    }

    static createLamelAreaFromLamellaListingItem(lamellaListingItem: LamellaListingItem, order = 1, groupId = uuid()): LamelareaImpl {
        const materialType = lamellaListingItem.defaultMaterial as 'Powder Coated' | 'Anodized';
        const lamellaSets = [LamellaSetFactory.createLamellaSetFromLamellaListingItem(lamellaListingItem)];
        return new LamelareaImpl(
            uuid(),
            order,
            lamellaListingItem.productName,
            groupId,
            lamellaSets,
            lamellaSets.length,
            "horizontal",
            true,
            2000,
            1500,
            true,

            null,
            MountingProfileFactory.createProfile( { productCode: 'P-22284', materialType, color: lamellaListingItem.defaultMaterialColor } ),
            null,

            true,
            false,

            true,
        );
    }

    static cloneLamelArea(lamelArea: LamelareaImpl): LamelareaImpl {
        return new LamelareaImpl(
            uuid(),
            lamelArea.order,
            "No name",
            lamelArea.groupId,
            lamelArea.lamellaSets.map(LamellaSetFactory.cloneLamellaSet),
            lamelArea.lamellaSets.length,
            lamelArea.orientation,
            true,
            lamelArea.width,
            lamelArea.height,
            true,
            lamelArea.coverProfile,
            lamelArea.mountingProfile,
            lamelArea.frameProfile,
            lamelArea.syncMountingProfile,
            lamelArea.syncCoverProfile,
            lamelArea.automaticFrames,
            lamelArea.assemblyAutoConfig,
            lamelArea.assemblyArray,
            lamelArea.framePositions
        );
    }



   /*static createLamelareaFromData(data: any): Lamelarea {
        const lamels = data.lamels.map((lamel: any) => new LamelImpl(lamel.id, lamel.name));
        return new LamelareaImpl(data.order, data.materialType, lamels);
    }

    static createLamelareaFromJSON(json: string): Lamelarea {
        return LamelareaImpl.fromJSON(json);
    }

    static lamelareaToJSON(lamelarea: Lamelarea): string {
        return (lamelarea as LamelareaImpl).toJSON();
    }

    private static getOrder(): number {
        return this.lamelAreaStore.getLamelAreas().length + 1;
    }*/
}